enum ROUTES {
  REPORTS = '/reports',
  REPORTS_BALANCE = '/reports/balance',
  REPORTS_BALANCE_SHEET = '/reports/balance/sheet',
  REPORTS_BALANCE_FRS = '/reports/balance/frs',

  REPORTS_ACCOUNTS_BALANCE = '/reports/account-balance',

  REPORTS_PROFIT_lOSS = '/reports/profit-loss',
  REPORTS_PROFIT_lOSS_SHEET = '/reports/profit-loss/sheet',
  REPORTS_PROFIT_lOSS_FRS = '/reports/profit-loss/frs',

  REPORTS_SAFEGUARDING = '/reports/safeguarding',
  REPORTS_SAFEGUARDING_FIAT = '/reports/safeguarding/fiat',
  REPORTS_SAFEGUARDING_CRYPTO = '/reports/safeguarding/crypto',

  REPORTS_CAPITAL_ADEQUACY = '/reports/capital-adequacy',

  REPORTS_BANK_AND_PSP = '/reports/bank-and-psp',

  REPORTS_CURRENCY_POSITION = '/reports/currency-position',

  REPORTS_REVALUATION = '/reports/revaluation',

  TRANSACTION_STATUS_REPORT = '/reports/transaction-status',

  REPORTS_NOTIFICATIONS_CENTER = '/reports/notification-center',

  REPORTS_ACCOUNTING_MANAGMENT = '/reports/accounting-managment',
  REPORTS_ACCOUNTING_MANAGMENT_LIST = '/reports/accounting-managment/list',
  REPORTS_ACCOUNTING_MANAGMENT_ITEM = '/reports/accounting-managment/list/:itemId',
  REPORTS_ACCOUNTING_MANAGMENT_CREATE = '/reports/accounting-managment/list/create',

  WARNING_REPORT = '/reports/warning-report',
  WARNING_REPORT_OVERVIEW = '/reports/warning-report/overview',
  WARNING_REPORT_CUSTOMERS = '/reports/warning-report/customers',
  WARNING_REPORT_CUSTOMERS_DETAILS = '/reports/warning-report/customers/:organizationId',
  WARNING_REPORT_LIST = '/reports/warning-report/list',
  WARNING_REPORT_LIST_DETAILS = '/reports/warning-report/list/:warningId',

  FINTRAC = '/reports/fintrac',
  FINTRAC_REPORTS = '/reports/fintrac/reports',
  FINTRAC_EFTR = '/reports/fintrac/reports/eftr',
  FINTRAC_EFTR_CREATE = '/reports/fintrac/reports/eftr/create',
  FINTRAC_DETAILS = '/reports/fintrac/:reportId',
  FINTRAC_LVCTR = '/reports/fintrac/reports/lvctr',
  FINTRAC_LVCTR_CREATE = '/reports/fintrac/reports/lvctr/create',
}

export default ROUTES;
